import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AnalyticsBrowser } from '@segment/analytics-next';
import { useLocalization } from '~/composables/_next/useLocalization';
import { AZ_COUNTRY_COOKIE } from '~/constants/localization';
var analytics = new AnalyticsBrowser();
var loaded = false;
export function useSegment() {
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    country = _useLocalization.country,
    locale = _useLocalization.locale,
    currency = _useLocalization.currency;
  var countryBasedOnIp = useCookie(AZ_COUNTRY_COOKIE);
  var _useRuntimeConfig = useRuntimeConfig(),
    writeKey = _useRuntimeConfig.public.segmentWriteKey;
  var route = useRoute();

  /**
   * Loads Segment script.
   * https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
   *
   * @returns {AnalyticsBrowser} - Resolves Segment instance.
   */
  function loadSegment() {
    if (process.server) {
      throw new Error('Segment is only available client side');
    }
    if (loaded || !writeKey) {
      return analytics;
    }
    analytics = analytics.load({
      writeKey: writeKey
    });
    loaded = true;
    analytics.catch(function (error) {
      $sentry.captureException(error);
    });
    window.analytics = analytics;
    return analytics;
  }
  function track(event, properties) {
    analytics.track(event, _objectSpread(_objectSpread({}, properties), {}, {
      country: country,
      locale: locale,
      currency: currency
    }));
  }
  function trackPage(category, name, properties) {
    analytics.page(category, name, _objectSpread(_objectSpread({}, properties), {}, {
      path: route.fullPath,
      country: country,
      locale: locale,
      currency: currency,
      country_based_on_ip: countryBasedOnIp.value
    }));
  }
  return {
    analytics: analytics,
    loadSegment: loadSegment,
    track: track,
    trackPage: trackPage
  };
}